/**
 * Public bundle initialization
 */
import {initCssSizing} from "../helpers/sizing/sizing";
import {scrollToElement} from "../helpers/scrolling/scrolling";
import {stopLoading} from "../helpers/loading";
import {initDelegatedTooltips} from "../common/initDelegatedTooltips";
import {initDelegatedCopyButtons} from "../common/initDelegatedCopyButtons";

const {initFullPageLoading} = require("../helpers/loading");
window._ = require('lodash');

try {
    // Load Jquery
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {
}

// Import swal
window.Swal = require('sweetalert2')

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Used on handleAjaxError.js and maybe somewhere else
 */
window.scrollToElementNative = scrollToElement;

/**
 * Init loading overlay
 */
initFullPageLoading()

/**
 * Init css sizing variables
 */
initCssSizing()

// Delegated tooltips support static views and AJAX-injected fragments.
initDelegatedTooltips();
initDelegatedCopyButtons();

/**
 * Run this after after dom is loaded and components are initialized
 */
function afterComponentLoadBootstrap() {
    // Hook onto pageshow to detect when the user goes back to a previous page
    window.addEventListener("pageshow", event => {
        if (event.persisted) {
            // Hide loading screens (if any) when coming back to a page
            // that was cached
            stopLoading();
        }
    });

    if ("virtualKeyboard" in navigator) {
        // TODO: Do this properly
        navigator.virtualKeyboard.overlaysContent = true;

        navigator.virtualKeyboard.addEventListener("geometrychange", () => {
            requestAnimationFrame(() => {
                // noinspection JSUnresolvedVariable
                const keyboardRect = navigator.virtualKeyboard.boundingRect;

                if (keyboardRect.height > 10) {
                    document.body.style.paddingBottom = `45vh`;
                } else {
                    document.body.style.paddingBottom = `0`;
                }
            })
        })
    }
}


export {afterComponentLoadBootstrap};
